(function () {
  'use strict';

  /* @ngdoc object
   * @name events.edit
   * @description
   *
   */
  angular
    .module('events.edit', [
      'ui.router'
    ]);
}());
